// extracted by mini-css-extract-plugin
module.exports =  {"link":"Link-module__link___bnulR","link__text":"Link-module__link__text___kqbRs","linkDisabled":"Link-module__linkDisabled___y4Nwz"};